module.exports = (__webpack_require__("5knLEQW+"))(2240);